<!-- Hub Selector -->
 <!-- Iterate through the sharerHubs and display the hub name -->
  <!-- Handle the selection of the hub -->
<div class="hub-selector-container">
  <div class="hub-selector-header">
    <h1>Hub Selector</h1>
  </div>
  <div class="hub-selector-content">
    <div class="hub-selector-item" *ngFor="let hub of sharerHubs">
      <h2>{{ hub }}</h2>
      <button (click)="selectHub(hub)">Select</button>
    </div>
  </div>
</div>